/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Bold_Otter_ExportInputs */

const fr_quiet_bold_otter_export = /** @type {(inputs: Quiet_Bold_Otter_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter en CSV`)
};

/**

* @param {Quiet_Bold_Otter_ExportInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const quiet_bold_otter_export = /** @type {((inputs?: Quiet_Bold_Otter_ExportInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Bold_Otter_ExportInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_quiet_bold_otter_export(inputs)
});